import * as React from 'react';
import styled from 'styled-components';
import Project from '../../../domain/entity/Project';
import { RoundMonitorVariationListItem } from './RoundMonitorVariationListItem';

interface IProps {
  project: Project;
}

const VariationList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;

  @media (min-width: 768px) {
    flex-direction: row;
    overflow-x: auto;
  }
`;

export class RoundMonitorVariationList extends React.Component<IProps, {}> {
  public render() {
    const { project } = this.props;
    const { variations } = project.round;
    return (
      <VariationList>
        {variations.map(variation => (
          <RoundMonitorVariationListItem key={variation.id} project={project} variation={variation} />
        ))}
      </VariationList>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/RoundMonitor/RoundMonitorVariationList.tsx